document.addEventListener('DOMContentLoaded', function () {
  fetch(window.location.pathname + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      document.addEventListener('click', function (e) {
        const thumbnail = e.target.closest('[data-media-id]');
        if (!thumbnail) return;
        const rawId = thumbnail.dataset.mediaId;
        const mediaId = rawId.split('-').pop();
        const match = product.variants.find(function (v) {
          return v.featured_media && String(v.featured_media.id) === mediaId;
        });
        if (!match) return;
        match.options.forEach(function (val) {
          const input = Array.from(
            document.querySelectorAll('variant-selects input[type="radio"]')
          ).find(function (i) { return i.value === val; });
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
});
